export default __webpack_public_path__ + "static/media/235.d50b1209.png";